/**
 * @file
 * Custom scripts for theme.
 */
(function ($) {

  Drupal.behaviors.fullScreenBehavior = {
		    attach: function (context) {
		    	Drupal.behaviors.fullScreenBehaviorCreator(context);
		    	Drupal.behaviors.fullScreenProfileWeChatCreator(context);
		    	Drupal.behaviors.fullScreenProfileVideoOverlayCreator(context);
		    	Drupal.behaviors.fullScreenWeChatCreator(context);
		    }
  }
  
  Drupal.behaviors.fullScreenBehaviorCreator = function (context) {
	  //Drupal.behaviors.functions.consolog("fullScreenBehavior");
	  
	//Standard FullScreenBehavior  
  	$(".fullScreenBehavior img, .fullScreenBehavior .videoOverlay",context).each(function (){
	    	var isAlreadyModified = $(this).data("saphfullscreen-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	
	    	if(!$(this).hasClass("noFullScreenBehavior")){

					$(this).click(function() {
						Drupal.behaviors.fullScreenClickHandler($(this));
					});

	    	  $(this).swipe( {
	    		    //Generic swipe handler for all directions
	    		    tap:function() {
	    		    		Drupal.behaviors.fullScreenClickHandler($(this));
	    		    },
	    	  		threshold: 10
	    	  });
	    	}
		
		if(!$(this).hasClass("videoOverlay") && !$(this).hasClass("noFullScreenBehavior") ){
    			$( this ).addClass("cursor-zoom-in");			    			
		}else{
			$( this ).addClass("cursor-pointer");
		}
		$(this).data("saphfullscreen-done",true);
	});	
  }
  
  Drupal.behaviors.fullScreenProfileWeChatCreator = function (context) {
		var isAlreadyModified = $("#artistProfileWeChat").data("saphfullscreen-done");
		if(isAlreadyModified){
			return true;
		}
	  	
	    $("#artistProfileWeChat").on('show.bs.modal', function () {
	    		$(this).css("padding-right","");
	    		var wechatSrc = $(this).data("wechat-image");
	    		$(".weChatQrImage img", this).attr("src", wechatSrc);
	    	});
	    
        $("#artistProfileWeChat").on('shown.bs.modal', function () {
    			$(this).css("padding-right","");
        });
	    
	    $("#artistProfileVideoModal").on('hidden.bs.modal', function () {
	    		$(".weChatQrImage img", this).attr("src", "");
	    });
	    $("#artistProfileWeChat").data("saphfullscreen-done",true);
  }
  
  Drupal.behaviors.fullScreenWeChatCreator = function (context) {
		var isAlreadyModified = $("#footerWeChat").data("saphfootWeChat-done");
		if(isAlreadyModified){
			return true;
		}
	  	
	    $("#footerWeChat").on('show.bs.modal', function () {
	    		$(this).css("padding-right","");
	    	});
	    
	    $("#footerWeChat").on('shown.bs.modal', function () {
  			$(this).css("padding-right","");
	    });
	    

	    $("#footerWeChat").data("saphfootWeChat-done",true);
  }  
  
  Drupal.behaviors.fullScreenProfileVideoOverlayCreator = function (context) {
		var isAlreadyModified = $("#artistProfileVideoModal").data("saphfullscreen-done");
		if(isAlreadyModified){
			return true;
		}
	  	
        $("#artistProfileVideoModal").on('show.bs.modal', function () {
	    		var videoType = $(this).data("video-type");
	    		var videoIdentifier = $(this).data("video-identifier");
	    		if(videoType == "youtube"){
	    			$(".youtube-videoEmbedFrame",this).removeClass("hideElement");
	    			$(".youtube-videoEmbedFrame iframe",this).attr("src", "https://www.youtube.com/embed/" + videoIdentifier + "?autoplay=1");
	    		}else if(videoType == "vimeo"){
	    			$(".vimeo-videoEmbedFrame",this).removeClass("hideElement");
	    			$(".vimeo-videoEmbedFrame iframe",this).attr("src", "https://player.vimeo.com/video/" + videoIdentifier + "?title=0&byline=0&portrait=0");
	    		}
	    			
    		});
        $("#artistProfileVideoModal").on('shown.bs.modal', function () {
	    		$(this).css("padding-right","");
		});
    
	    $("#artistProfileVideoModal").on('hidden.bs.modal', function () {
	    		$(".videoEmbedFrame", this).each(function() {
	    			  $( this ).addClass( "hideElement" );
	    			  $("iframe",this).attr("src","");
	    		});
	    	});	 
	    $("#artistProfileVideoModal").data("saphfullscreen-done",true);
  }  
  
  
//  <iframe src="https://player.vimeo.com/video/224029961?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allowfullscreen></iframe>
//  <p><a href="https://vimeo.com/224029961">Swatch Montage</a> from <a href="https://vimeo.com/hellomono">Hello Mono</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
  
  
	// Function from David Walsh: http://davidwalsh.name/css-animation-callback
	Drupal.behaviors.whichTransitionEvent = function (){
	  var t,
	      el = document.createElement("fakeelement");

	  var transitions = {
	    "transition"      : "transitionend",
	    "OTransition"     : "oTransitionEnd",
	    "MozTransition"   : "transitionend",
	    "WebkitTransition": "webkitTransitionEnd"
	  }

	  for (t in transitions){
	    if (el.style[t] !== undefined){
	      return transitions[t];
	    }
	  }
	};
  
})(jQuery);